module.exports = __webpack_public_path__ + "franchise-the_division-mobile.png";